import moment from "moment";
import toast from "react-hot-toast";

// Currency Symbol
export const curSym = "$";
export const INcurSym = "₹";
export const UKcurSym = "£";
export const USAcurSym = "$";
export const NGcurSym = "₦";

// Authorization
export const pipSetAccessToken = (token) => {
  localStorage.setItem("securpoint-web-access-token", token);
};
export const pipGetAccessToken = () => {
  const token = localStorage.getItem("securpoint-web-access-token");
  return { token, isLogin: token ? true : false };
};

export const pipSaveProfile = (profile) => {
  localStorage.setItem("secure-point-profile", JSON.stringify(profile));
};
export const pipGetProfile = () => {
  const profile = localStorage.getItem("secure-point-profile");
  return profile ? JSON.parse(profile) : {};
};
// Date View Format
export const pipViewDate = (date) => {
  return moment(date).format("DD-MM-YYYY");
};

export const handleShareAsset = async (target) => {
  const id = typeof target === "object" ? (target?.id || target?.assetId) : target;
  if (!id) return;

  const assetName =
    typeof target === "object"
      ? target?.AssetName || target?.asset_name || target?.name || ""
      : "";
  const uic =
    typeof target === "object"
      ? target?.UIC || target?.uic || ""
      : "";
  const status =
    typeof target === "object"
      ? target?.status || (target?.lock === 2 ? "Stolen" : target?.lock === 0 ? "Locked" : "")
      : "";

  const baseUrl =
    typeof window !== "undefined" && window.location.origin
      ? window.location.origin
      : "https://securpoint.app";
  const url = `${baseUrl}/assets-detail/${id}`;

  const title = assetName
    ? `${assetName}${uic ? ` (UIC: ${uic})` : ""} - SecurPoint`
    : "SecurPoint - Asset Details";

  let textLines = ["Check out this asset on SecurPoint:"];
  if (assetName) textLines.push(`Asset Name: ${assetName}`);
  if (uic) textLines.push(`UIC: ${uic}`);
  if (status) textLines.push(`Status: ${status}`);
  textLines.push(`Link: ${url}`);
  const text = textLines.join("\n");

  const copyText = text;

  // Direct synchronous check and share to preserve browser user gesture
  if (typeof navigator !== "undefined" && navigator.share) {
    try {
      await navigator.share({
        title: title,
        text: text,
      });
      return;
    } catch (error) {
      if (error?.name === "AbortError") {
        // User dismissed/closed the share dialog - do not copy or toast
        return;
      }
      console.warn("Navigator share failed, falling back to clipboard:", error);
    }
  }

  // Fallback to clipboard copy only if Web Share is not supported or failed
  try {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      await navigator.clipboard.writeText(copyText);
      toast.success("Asset details & link copied to clipboard!");
    } else {
      const textarea = document.createElement("textarea");
      textarea.value = copyText;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
      toast.success("Asset details & link copied to clipboard!");
    }
  } catch (err) {
    console.error("Clipboard copy failed:", err);
  }
};
export const handleShareUserProfile = async (target) => {
  const id = typeof target === "object" ? target?.id : target;
  if (!id) return;
  const baseUrl =
    typeof window !== "undefined" && window.location.origin
      ? window.location.origin
      : "https://securpoint.app";
  const url = `${baseUrl}/user-detail/${id}`;

  try {
    if (navigator.share) {
      await navigator.share({
        title: "SecurPoint - User Profile",
        text: "Check out this user profile on SecurPoint",
        url: url,
      });
    } else if (navigator.clipboard) {
      await navigator.clipboard.writeText(url);
      toast.success("Profile link copied to clipboard!");
    } else {
      const textarea = document.createElement("textarea");
      textarea.value = url;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
      toast.success("Profile link copied to clipboard!");
    }
  } catch (error) {
    if (error?.name !== "AbortError") {
      try {
        await navigator.clipboard.writeText(url);
        toast.success("Profile link copied to clipboard!");
      } catch (err) {
        console.error("Share failed:", error);
      }
    }
  }
};

export const handleShareSecurePoint = async () => {
  const url = `https://securpoint.app`;

  try {
    if (navigator.share) {
      await navigator.share({
        title: "Check the web",
        text: "Check out this web",
        url: url,
      });
    } else {
      await navigator.clipboard.writeText(url);
      toast.success("Link copied!");
    }
  } catch (error) {
    console.error("Share failed:", error);
  }
};
export const tabs = [
  {
    lable: "Locked",
    svg: (
      <svg
        width="35"
        height="35"
        viewBox="0 0 35 35"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.6666 14.5833V10.2083C11.6666 8.66124 12.2812 7.17751 13.3752 6.08354C14.4691 4.98958 15.9529 4.375 17.5 4.375C19.0471 4.375 20.5308 4.98958 21.6247 6.08354C22.7187 7.17751 23.3333 8.66124 23.3333 10.2083V14.5833"
          stroke="black"
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <path
          d="M7.29163 14.5833H27.7083V27.7083C27.7083 28.4819 27.401 29.2237 26.854 29.7707C26.307 30.3177 25.5652 30.625 24.7916 30.625H10.2083C9.43474 30.625 8.69288 30.3177 8.1459 29.7707C7.59892 29.2237 7.29163 28.4819 7.29163 27.7083V14.5833Z"
          stroke="black"
          stroke-width="1.5"
          stroke-linejoin="round"
        />
        <path
          d="M21.1458 22.6042H21.1599V22.6184H21.1458V22.6042Z"
          stroke="black"
          stroke-width="2.25"
          stroke-linejoin="round"
        />
      </svg>
    ),
  },
  {
    lable: "Stolen",
    svg: (
      <svg
        width="35"
        height="35"
        viewBox="0 0 35 35"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.64587 5.83333C3.64587 5.44656 3.79952 5.07563 4.07301 4.80214C4.3465 4.52865 4.71743 4.375 5.10421 4.375H13.8542L17.5 8.75H29.8959C30.2826 8.75 30.6536 8.90365 30.9271 9.17714C31.2006 9.45063 31.3542 9.82156 31.3542 10.2083V29.1667C31.3542 29.5534 31.2006 29.9244 30.9271 30.1979C30.6536 30.4714 30.2826 30.625 29.8959 30.625H5.10421C4.71743 30.625 4.3465 30.4714 4.07301 30.1979C3.79952 29.9244 3.64587 29.5534 3.64587 29.1667V5.83333Z"
          stroke="black"
          stroke-width="2"
          stroke-linejoin="round"
        />
        <path
          d="M13.8542 16.0417L21.1459 23.3334M21.1459 16.0417L13.8542 23.3334"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
  },
  {
    lable: "Unlocked",
    svg: (
      <svg
        width="35"
        height="35"
        viewBox="0 0 35 35"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M28.4375 16.0767H6.56246C5.75704 16.0767 5.10413 16.7296 5.10413 17.535V30.66C5.10413 31.4654 5.75704 32.1183 6.56246 32.1183H28.4375C29.2429 32.1183 29.8958 31.4654 29.8958 30.66V17.535C29.8958 16.7296 29.2429 16.0767 28.4375 16.0767Z"
          stroke="black"
          stroke-width="2"
          stroke-linejoin="round"
        />
        <path
          d="M10.2083 16.0417V10.212C10.2046 6.46773 13.0688 3.33012 16.8335 2.95387C20.5982 2.57762 24.0384 5.08523 24.7916 8.75439M17.4999 21.875V26.25"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
  },
  {
    lable: "Promoted",
    svg: (
      <svg
        width="35"
        height="35"
        viewBox="0 0 35 35"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M29.1667 16.7709V10.2084L22.6042 2.91669H7.29171C6.90493 2.91669 6.534 3.07033 6.26051 3.34382C5.98702 3.61731 5.83337 3.98825 5.83337 4.37502V30.625C5.83337 31.0118 5.98702 31.3827 6.26051 31.6562C6.534 31.9297 6.90493 32.0834 7.29171 32.0834H16.0417"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M18.9584 27.7084L23.3334 31.3542L29.8959 23.3334M21.875 2.91669V10.2084H29.1667"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
  },
];

export const statusValueDefine = {
  Locked: {
    title: "Own your security. Protect what matters.",
    description:
      "Register and protect your valuables with smart security tools built for real-world threats.",
    img: "/assets/img/locked_banner_img.png",
  },
  Stolen: {
    title: "Report lost or stolen assets",
    description:
      "Quickly flag lost or stolen assets to alert others and increase the chances of recovery.",
    img: "/assets/img/stolen_banner_img.png",
  },
  Unlocked: {
    title: "Mark as unlocked to confirm your asset is safe",
    description:
      "Show that your assets are safe and securely under your control.",
    img: "/assets/img/unlocked_banner_img.png",
  },
  Promoted: {
    title: "Boost and promote your assets",
    description:
      "Increase visibility by promoting your assets across the platform, helping them reach a wider audience when it matters most.",
    img: "/assets/img/promoted_banner_img.png",
  },
};
